// useSmsTheme — dark-mode toggle scoped to the SMS portal.
//
// The standalone prototype toggled `.dark` on <html> globally. To avoid
// affecting the rest of the admin app, the portal layout instead binds `.dark`
// on its own wrapper element and Tailwind's class-based dark variant keys off
// that. Theme preference is the one value the prototype persisted (device-local
// localStorage), so that behaviour is kept.
import { ref } from "vue";

const STORAGE_KEY = "callia-sms-theme";

export function useSmsTheme() {
  const isDark = ref(false);

  try {
    const saved = localStorage.getItem(STORAGE_KEY);
    if (
      saved === "dark" ||
      (!saved && window.matchMedia("(prefers-color-scheme: dark)").matches)
    ) {
      isDark.value = true;
    }
  } catch (e) {
    /* localStorage unavailable — default to light */
  }

  function toggleTheme() {
    isDark.value = !isDark.value;
    try {
      localStorage.setItem(STORAGE_KEY, isDark.value ? "dark" : "light");
    } catch (e) {
      /* ignore persistence failures */
    }
  }

  return { isDark, toggleTheme };
}
